import { Button } from '@codegouvfr/react-dsfr/Button';
import { useCloseRefOnOuterClick } from '@common/hooks';
import { DebouncedInput } from '@common/ui';
import React, { useEffect, useRef, useState } from 'react';

export const SearchTextFilter = ({
                                   search: searchInput,
                                   onSearchChange,
                                   debounceTime,
                                   minLength,
                                   emitIfEmpty,
                                 }: SearchTextFilterProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  const ref = useRef<HTMLDivElement>(null!);

  useEffect(() => {
    setValue(searchInput ?? '');
  }, [searchInput]);

  useCloseRefOnOuterClick({ ref, setOpen: setIsOpen });

  const handleDebouncedValue = (text: string) => {
    const search = text.trim();

    if (emitIfEmpty && search === '') return onSearchChange?.('');
    if (search.length < (minLength ?? 0)) return;

    onSearchChange?.(text);
  };

  const handleKeyDown = (ev) => {
    if (ev.key === 'Escape') setIsOpen(false);
  };

  return (
    <div ref={ref}>
      <Button
        iconId="fr-icon-search-line"
        onClick={() => setIsOpen(s => !s)}
        priority="secondary"
        title="Filtrer par recherche"
      />

      {(isOpen) && (
        <div className={'absolute bg-white p-4 shadow-md z-40'}>
          <DebouncedInput
            debounceTime={debounceTime ?? 0}
            onDebounce={handleDebouncedValue}
            onKeyDown={handleKeyDown}
            value={value}
            onValueChange={setValue} />
        </div>
      )}
    </div>
  );
};

interface SearchTextFilterProps {
  search?: string;
  onSearchChange?: (search: string) => void;
  /**
   * Milliseconds
   */
  debounceTime?: number;
  /**
   * Min value length to trigger change
   * @default 0
   */
  minLength?: number;
  /**
   * Trigger onChange when value is empty
   */
  emitIfEmpty?: boolean;
}